import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

interface Props {
    children: JSX.Element;
    allowAdmin?: boolean;
    allowManager?: boolean;
}

const ProtectedRoute: React.FC<Props> = ({
    children,
    allowAdmin,
    allowManager
}) => {
    const { isAdmin, isManager } = useAuth();

    const isAuthorized =
        (allowAdmin && isAdmin) ||
        (allowManager && isManager);

    if (!isAuthorized) {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

export default ProtectedRoute;